module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5-2.8e3656e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5-2.png
// module id = yE+k
// module chunks = 34